<template>
  <b-button
    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
    v-b-tooltip.hover.v-success.top="$t(i18nHoverVariable)"
    variant="flat-success"
    class="btn-icon rounded-circle"
    @click="$emit('clicked')"
  >
    <feather-icon icon="CheckCircleIcon" />
  </b-button>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { VBTooltip } from 'bootstrap-vue'

export default {
  name: 'ValidateButton',
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  props: {
    i18nHoverVariable: {
      type: String,
      default: 'declaration.validate',
    },
  },
}
</script>

<style scoped>

</style>
